import { render, staticRenderFns } from "./CoursewareStructuralElementSelectorItem.vue?vue&type=template&id=bfed9568&"
import script from "./CoursewareStructuralElementSelectorItem.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementSelectorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports